import { render, staticRenderFns } from "./AcceptorLogsList.vue?vue&type=template&id=3a9c33de"
import script from "./AcceptorLogsList.vue?vue&type=script&lang=js"
export * from "./AcceptorLogsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports